import React, { useEffect, useState } from 'react'
import GlobalStyles from '../assets/styles/GlobalStyles'
import Counter from '../components/section/counter'
import Layout from '../common/layout'
import MintNowModal from '../common/modal/mintNowModal'
import WalletModal from '../common/modal/walletModal/WalletModal'
import PageHeader from '../common/pageHeader'
import Banner from '../components/section/banner/v3'
import CharacterSlider from '../components/section/characterSlider/v3'
import CTA from '../components/section/cta/v1'
import Footer from '../components/section/footer/v3'
import FooterBottom from '../components/section/footer/v3/footerBottom/FooterBottom'
import Header from '../components/section/header/mint/Header'
import { useModal } from '../utils/ModalContext'
import { useWeb3Contract, useMoralis } from 'react-moralis'
import abi from "../controllers/abi.json";
import OopsModal from '../common/modal/oopsModal/OopsModal'
import NoWalletModal from '../common/modal/noWalletModal/NoWalletModal'
import ShareModal from '../common/modal/shareModal/ShareModal'
import SuccessModal from '../common/modal/successModal/SuccessModal'

const contractAddress = "0xb07278eeb48df1df1e42ffe1c8cc1a3a912d140f"

const Mint = () => {

    const { visibility, walletModalvisibility, oopsModalVisibility, noWalletVisibility,shareModalVisibility, successVisibility } = useModal();
  return (
    <>
      <Layout>
        <GlobalStyles />
        {visibility && <MintNowModal/>}
        {walletModalvisibility && <WalletModal />}
        {oopsModalVisibility && <OopsModal />}
        {shareModalVisibility && <ShareModal />}
        {noWalletVisibility && <NoWalletModal />}
        {successVisibility && <SuccessModal />}
        <Header />
        <Banner/>
        <CharacterSlider />
        <Counter />

        {/* <BlogList /> */}
        {/* <CTA /> */}
        <FooterBottom />
      </Layout>
    </>
  )
}

export default Mint